function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.9584 22.6869c0 1.2262-1.1085 2.2764-2.3001 2.2764H45.498v3.4694h1.1603c3.1641 0 5.7605-2.5896 5.7605-5.7458v-6.3972h6.0557v12.143h3.4603V12.8203H48.9584v9.8666Zm28.5477-1.1965c0 2.4671-1.7783 4.6872-4.239 4.6872h-.173c-2.4607 0-4.239-1.9397-4.239-4.6872v-8.6701h-3.4604v8.6701c0 5.2076 3.5609 7.8097 7.6994 7.8097h.173c1.8455 0 3.2882-.6133 4.239-1.7347v1.0408c0 3.2802-2.0859 4.597-4.239 4.597h-.173c-1.8455 0-3.5679-1.2677-4.239-2.8938l-2.8801 1.0653c1.0905 2.7756 3.9873 4.8643 7.1191 4.8643h.173c4.4181 0 7.6993-3.2312 7.6993-7.6328V12.8203h-3.4603v8.6701Zm19.0328-2.5986v-6.0715h3.4604v15.6124h-3.4604v-6.0715H87.888v6.0715h-3.4604V12.8203h3.4604v6.0715h8.6509Z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 11.0527c0-.1476.0810916-.2834.211129-.3534L17.2064 1.54799c.1188-.06399.2618-.06399.3806 0l16.9953 9.15131c.13.07.2111.2058.2111.3534v19.8732c0 .1467-.08.2817-.2087.3521l-16.9953 9.2993c-.1201.0657-.2653.0657-.3854 0L.208756 31.278C.0800415 31.2076 0 31.0726 0 30.9259V11.0527Z",
  fill: "url(#paint0_linear_1005_117)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m17.3965 20.3319 17.3967-9.5189v20.3509l-17.3967 9.5189V20.3319Z",
  fill: "url(#paint1_linear_1005_117)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3967 20.515 0 10.813l17.3967-9.36744L34.7934 10.813l-17.3967 9.702Z",
  fill: "url(#paint2_linear_1005_117)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.3967 20.3319 0 10.813v20.3509l17.3967 9.5189V20.3319Z",
  fill: "url(#paint3_linear_1005_117)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.0000325 10.813H0v20.3508l17.3967 9.519 17.3967-9.519V10.813L17.3967 1.44556.0000325 10.813Z",
  fill: "url(#paint4_linear_1005_117)"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_1005_117)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3967 20.3319 0 10.813v20.3509l17.3967 9.5189V20.3319Z",
  fill: "url(#paint5_linear_1005_117)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f_1005_117)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m-.335938 10.4785 17.731238 9.702",
  stroke: "url(#paint6_linear_1005_117)",
  strokeWidth: 0.468373,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_1005_117)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m35.1258 10.4785-17.7313 9.702",
  stroke: "url(#paint7_linear_1005_117)",
  strokeWidth: 0.468373,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_1005_117)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3945 41.9264V20.1805",
  stroke: "url(#paint8_linear_1005_117)",
  strokeWidth: 0.468373,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_1005_117)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m-.335938 10.4785 17.731238 9.702",
  stroke: "url(#paint9_linear_1005_117)",
  strokeWidth: 0.401462,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_1005_117)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m35.1258 10.4785-17.7313 9.702",
  stroke: "url(#paint10_linear_1005_117)",
  strokeWidth: 0.401462,
  strokeLinecap: "round"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_f_1005_117)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3945 41.9264V20.1805",
  stroke: "url(#paint11_linear_1005_117)",
  strokeWidth: 0.401462,
  strokeLinecap: "round"
})));

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1005_117",
  x1: 17.3967,
  y1: 18.1804,
  x2: 0.035424,
  y2: 31.2382,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5201"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.510417,
  stopColor: "#EB3D00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D42600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1005_117",
  x1: 34.4649,
  y1: 11.4695,
  x2: 17.7247,
  y2: 40.6828,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8004"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5201"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1005_117",
  x1: 17.3967,
  y1: 1.78011,
  x2: 17.3967,
  y2: 20.515,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF6605"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8A06"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1005_117",
  x1: 17.3967,
  y1: 18.1731,
  x2: -0.00000177,
  y2: 31.2207,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5201"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.510417,
  stopColor: "#EB3D00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D42600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1005_117",
  x1: 17.3967,
  y1: 18.1732,
  x2: -0.00000168,
  y2: 31.2207,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5201"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.510417,
  stopColor: "#EB3D00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D42600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1005_117",
  x1: 14.0512,
  y1: 19.1768,
  x2: 10.0366,
  y2: 37.2426,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF0101",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DD2800",
  stopOpacity: 0.71
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1005_117",
  x1: -0.00138587,
  y1: 11.4822,
  x2: 17.3953,
  y2: 20.8496,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8708"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_1005_117",
  x1: 35.1258,
  y1: 10.4785,
  x2: 17.7291,
  y2: 19.846,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9B06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_1005_117",
  x1: 52730,
  y1: 40.6495,
  x2: 52730,
  y2: 20.1827,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_1005_117",
  x1: -0.00138587,
  y1: 11.4822,
  x2: 17.3953,
  y2: 20.8496,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8708"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_1005_117",
  x1: 35.1258,
  y1: 10.4785,
  x2: 17.7291,
  y2: 19.846,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF9B06"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_1005_117",
  x1: 52730,
  y1: 40.6495,
  x2: 52730,
  y2: 20.1827,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF5402"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f_1005_117",
  x: -1.23942,
  y: 9.57516,
  width: 19.5374,
  height: 11.5087,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.334552,
  result: "effect1_foregroundBlur_1005_117"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_1005_117",
  x: 16.4911,
  y: 9.57516,
  width: 19.5374,
  height: 11.5087,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.334552,
  result: "effect1_foregroundBlur_1005_117"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_1005_117",
  x: 16.4911,
  y: 19.2772,
  width: 1.80696,
  height: 23.5524,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.334552,
  result: "effect1_foregroundBlur_1005_117"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_1005_117",
  x: -0.737841,
  y: 10.077,
  width: 18.5343,
  height: 10.5051,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.100366,
  result: "effect1_foregroundBlur_1005_117"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_1005_117",
  x: 16.9926,
  y: 10.077,
  width: 18.5343,
  height: 10.5051,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.100366,
  result: "effect1_foregroundBlur_1005_117"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_f_1005_117",
  x: 16.9926,
  y: 19.779,
  width: 0.803806,
  height: 22.5488,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.100366,
  result: "effect1_foregroundBlur_1005_117"
})));

function SvgLunLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    viewBox: "0 0 100 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1005_117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 35,
    height: 40
  }, _ref3), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1005_117)"
  }, _ref4, _ref5, _ref6, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1005_117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 35,
    height: 40
  }, _ref7), _ref8), _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunLogo);
export default __webpack_public_path__ + "static/media/lun-logo.69f786f1.svg";
export { ForwardRef as ReactComponent };